<template>

  <div id="app">
    <router-view/>
    <div class="loading-wrap" v-show="loadingState">
      <i class="loading el-icon-loading vi-color"></i>
    </div>
    
    <div class="fs-12 c-8 ta-c">
      Copyright © 2020 广东财臣科技有限公司<a href="https://beian.miit.gov.cn">粤ICP备20024161号-2</a>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {}
  },
  computed: {
    loadingState() {
      return this.$store.state.loadingState
    }
  }
}
</script>

<style lang="less" scoped>
.loading-wrap {
  position: fixed;
  z-index: 99999;
  left: 0;
  top: 0;
  bottom: 0;
  right: 0;
  .loading {
    position: absolute;
    left: 50%;
    transform: translateX(-50%);
    top: 40px;
    font-size: 50px;
  }
}


.beian {
  text-align: center;
  font-size: 12px;
  align-items: center;
  color:#888;
  a {
  color: #888
}
}

</style>



// WEBPACK FOOTER //
// src/App.vue